module.exports = __webpack_public_path__ + "static/media/highlight-comments.5903fe12.svg";